export function isSameRoute(path: string, redirectUrl: string) {
  return path.indexOf(redirectUrl) >= 0
}
